import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables');
}

// Create a single supabase client for interacting with your database
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    storage: window.localStorage,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    debug: true // Enable debug logging for auth issues
  },
  db: {
    schema: 'public'
  },
  global: {
    headers: {
      'x-client-info': 'taras-tarot@0.1.0'
    }
  },
  // Add request timeouts
  realtime: {
    timeout: 60000
  }
});

// Log Supabase client configuration
console.log('Supabase client configured:', {
  url: supabaseUrl,
  hasAnonKey: !!supabaseAnonKey,
  persistSession: true,
  schema: 'public',
  debug: true
});

// Add session state listener
supabase.auth.onAuthStateChange((event, session) => {
  console.log('Auth state changed:', event, 'Session:', !!session);
});